export default "__VITE_ASSET__9$dWUeh$__"